import type { DeadEndProps } from '../../'
import { data } from './data'

export const useMonitoringPageDeadEndData = (): DeadEndProps => data
